import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getLegalBranding } from './siteConfig.js';

function LegalDocumentPage({ isMobile, content }) {
  const branding = getLegalBranding();

  useEffect(() => {
    document.title = `${content.title} | ${branding.siteName}`;
    return () => {
      document.title = `${branding.shortName} Community`;
    };
  }, [content.title, branding.siteName, branding.shortName]);

  return (
    <div className={`docs-page ${isMobile ? 'docs-page-mobile' : ''}`}>
      <article className="docs-card">
        <header className="docs-header">
          <h1 className="docs-title">{content.title}</h1>
          <p className="docs-meta" style={{ whiteSpace: 'pre-line' }}>{content.meta}</p>
          {branding.isDemo && (
            <p className="legal-demo-notice">
              Demonstration site — legal text applies to the platform; sample data is fictional.
            </p>
          )}
        </header>

        {content.sections.map((section) => (
          <section key={section.heading} className="docs-section">
            <h2>{section.heading}</h2>
            {section.body?.map((paragraph) => (
              <p key={paragraph.slice(0, 24)}>{paragraph}</p>
            ))}
            {section.subsections?.map((sub) => (
              <div key={sub.title}>
                <h3>{sub.title}</h3>
                {sub.text && <p>{sub.text}</p>}
                {sub.list && (
                  <ul>
                    {sub.list.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
            {section.list && (
              <ul>
                {section.list.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
            {section.contact && (
              <p>
                {branding.legalEntity}
                <br />
                Email:{' '}
                <a href={`mailto:${branding.contactEmail}`} className="docs-link">
                  {branding.contactEmail}
                </a>
                <br />
                Website:{' '}
                <a href={branding.websiteUrl} className="docs-link">
                  {branding.websiteUrl.replace(/^https?:\/\//, '')}
                </a>
              </p>
            )}
          </section>
        ))}

        <footer className="docs-footer">
          <Link to={branding.isDemo || branding.marketingSite ? '/' : '/'} className="docs-link">
            Return to home
          </Link>
          {' · '}
          <Link to="/privacy" className="docs-link">Privacy Policy</Link>
          {' · '}
          <Link to="/terms" className="docs-link">Terms and Conditions</Link>
        </footer>
      </article>
    </div>
  );
}

export default LegalDocumentPage;